import { render, staticRenderFns } from "./AddNewGiftModal.vue?vue&type=template&id=0d6d992a&"
import script from "./AddNewGiftModal.vue?vue&type=script&lang=js&"
export * from "./AddNewGiftModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports